module.exports = __webpack_public_path__ + "static/media/conner-full.ff1fd4f6.png";